<template>
  <div
    :class="[
        'wg-row msg-container',
        !sameUser ? 'same-user' : '',
        // Se è valorizzato user il messaggio deve comparire come mio
        msg.user ? 'personal' : '',
        sending ? 'temp' : ''
      ]"
  >
     <img 
        v-if="!isSynchronized" 
        class="com-anm22-app-img-fixed-height-m"
        :src="$anm22.icons.getWorldIcon('offline')" 
        style="margin-right:5px;"
        :title="$anm22.strLang(lang, 'Not synchronized', 'Non sincronizzato')"
      >  
    <img class="type-icon" :style="{backgroundColor: msgIcon.color,padding:(msg.data.type == 'call' || msg.data.type == 'msg') && (msg.data.category && msg.data.category != 'other' && msg.data.category != 'sms') ? '0' : ''}" :src="msgIcon.icon" />
    <!-- Per ogni tipologia di msg il corpo viene renderizzato da un componente specifico -->
    <component :is="msgComponent" :msg="msg"></component>
    <div v-if="boardFeedAssoc.length > 0" class="wg-row" style="width:auto;">
      <div
        style="height:14px;"
        v-for="(project,index) in assocProjects"
        :key="'assoc' + index"
        :title="project.projectId ? project.projectId + ' - ' + project.name : project.name"
      >
        <a :href="'https://tasks.anm22.it/project/' + project.idWorldProject" target="_blank">
          <img
            :src="$anm22.icons.getWorldIcon('menuTasksGreen')"
            class="com-anm22-app-img-fixed-height-m"
            style="margin-left:7px;display:inline-block;cursor:pointer;"
          />
        </a>
      </div>
    </div>
    <template v-if="msg.data.contentType !== 'HTML' &&  msg.data.type != 'reminder'">
      <img v-if="msg.data.type != 'changeStatus' && msg.data.type != 'actionMsg'"
        class="msg-action-btn"
        :src="$anm22.icons.getWorldIcon('edit')"
        @click="edit = true"
      />
      <img
        class="msg-action-btn"
        :src="$anm22.icons.getWorldIcon('deleteBin')"
        @click="showDeleteDialog = true"
      />
    </template>
    <img
      v-if="msg.data.type != 'reminder' && msg.data.type != 'changeStatus'"
      :src="$anm22.icons.getWorldIcon('shareFeed')"
      :title="$anm22.strLang(lang, 'Share this feed', 'Condividi questo feed')"
      class="com-anm22-app-img-fixed-height-m msg-action-btn"
      @click="openImportDialog = true"
    />
    <wg-modal :confirmOnClose="true" :confirmOnCloseMsg="$anm22.strLang(lang, 'Cancel changes to the feed?', 'Annullare modifiche al feed?')" v-if="edit" :width="windowWidth > 700 ? '700px' : '90%'" @closeModal="resetFeed">
      <div class="com-anm22-app-text-l" slot="header">{{ $anm22.strLang(lang, 'Edit', 'Modifica') }}</div>
      <new-feed-dialog slot="body" :contactId="contactId" :edit="edit" :msgRef="msg"></new-feed-dialog>
    </wg-modal>
    <wg-modal v-if="showDeleteDialog" @closeModal="showDeleteDialog = false;">
      <div class="wg-row" style="justify-content:center;" slot="body">
        <div
          class="com-anm22-app-text-xl"
        >{{ $anm22.strLang(lang, 'Delete feed?', 'Cancellare messaggio?') }}</div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row" style="align-items:center;justify-content:center;">
          <input
            type="button"
            class="small com-anm22-button-blue"
            :value="$anm22.strLang(lang, 'OK', 'OK')"
            @click="removeFeed"
          />
          <div class="com-anm22-app-horizontal-space" style="width:20px;"></div>
          <input
            type="button"
            class="small com-anm22-button-red"
            :value="$anm22.strLang(lang, 'Cancel', 'Annulla')"
            @click="showDeleteDialog = false;"
          />
        </div>
      </div>
    </wg-modal>
    <wg-modal v-if="openImportDialog" @closeModal="openImportDialog = false">
      <div
        class="com-anm22-app-text-l"
        slot="header"
      >{{ $anm22.strLang(lang, 'Share feed', 'Condividi feed ') }}</div>
      <import-feed :msg="msg" :contactId="contactId" slot="body"></import-feed>
    </wg-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import FeedItemCall from "./feed-msgs/FeedItemCall.vue";
import FeedItemMsg from "./feed-msgs/FeedItemMsg.vue";
import FeedItemMeeting from "./feed-msgs/FeedItemMeeting.vue";
import FeedItemReminder from "./feed-msgs/FeedItemReminder.vue";
import FeedItemActionMsg from "./feed-msgs/FeedItemActionMsg.vue";
import FeedItemChangeStatus from "./feed-msgs/FeedItemChangeStatus.vue";
import NewFeedDialog from "./NewFeedDialog.vue";
import ImportFeed from "./ImportFeed.vue";

export default {
  props: {
    msg: Object,
    sameUser: {
      type: Boolean,
      default: false
    },
    sending: {
      type: Boolean,
      default: false
    },
    contactId: [String, Number]
  },
  data() {
    return {
      openImportDialog: false,
      edit: false,
      showDeleteDialog: false
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      windowWidth: state => state.windowWidth
    }),
    contact() {
      return this.$store.getters["contacts/get"](this.contactId);
    },
     isSynchronized() {
      return this.$store.getters['offline/isSynchronized'](this.$anm22.MD5('WorldMessage' + this.msg.idWorldMessage));
    },
    msgUser() {
      return this.$store.getters["users/get"](this.msg.user);
    },
    msgComponent() {
      return "FeedItem" + this.$anm22.capitalizeFirst(this.msg.data.type);
      // switch(this.msg.data.type) {
      //   case 'call':
      //     return 'FeedItemCall';
      //     break;
      //   case 'msg':
      //     return 'FeedItemMsg';
      //     break;
      //   case 'meeting':
      //     return 'FeedItemMeeting';
      //     break;
      //   case 'reminder':
      //     return 'FeedItemReminder';
      //     break;
      //   case 'actionMsg':
      //     return 'FeedItemActionMsg';
      //     break;
      // }
    },
    msgText() {
      switch (this.msg.data.type) {
        case "call":
          return this.msg.data.description;
          break;
        case "msg":
          return this.msg.data.text;
          break;
        case "meeting":
          return this.msg.data.description;
          break;
        case "reminder":
          return this.msg.data.description;
          break;
        case "actionMsg":
          return this.msg.data.description;
          break;
      }
    },
    boardFeedAssoc() {
      return this.$store.getters["feedBoardAssocs/getByContactMessage"](
        this.msg.idWorldMessage
      );
    },
    assocProjects() {
      return this.boardFeedAssoc.map(assoc =>
        this.$store.getters["projects/get"](assoc.project)
      ).filter(p => p);
    },
    msgIcon() {
      switch (this.msg.data.type) {
        case "call":
          if(this.msg.data.category && this.msg.data.category != 'other') {
            return {
              icon: this.getImageByCategory(this.msg.data.category),
              color: ""
            }
          } else {
            return {
              icon: this.$anm22.icons.getWorldIcon("phoneWhite"),
              color: "orange"
            };
          }
          break;
        case "msg":
           if(this.msg.data.category && this.msg.data.category != 'other' && this.msg.data.category != 'sms') {
            return {
              icon: this.getImageByCategory(this.msg.data.category),
              color: ""
            }
          } else {
          return {
            icon: this.$anm22.icons.getWorldIcon("chatWhite"),
            color: "#0aabf4"
          };
          }
          break;
        case "meeting":
          return {
            icon: this.$anm22.icons.getWorldIcon("placeWhite"),
            color: "red"
          };
          break;
        case "reminder":
          return {
            icon: this.$anm22.icons.getWorldIcon("reminderWhite"),
            color: "#777777"
          };
          break;
        case "actionMsg":
          return {
            icon: this.msg.data.icon,
            color: this.msg.data.color || "none"
          };
          break;
        case "changeStatus":
          return {
            icon: this.$anm22.icons.getWorldIcon("viewCols"),
            color: ''
          };
          break;
      }
    }
  },
  methods: {
    resetFeed() {
      //this.$parent.msg = {...this.oldMsg};
      this.edit = false;
    },
    getLastFeedDate(contact,msg) {
      let msgs = this.$store.getters['messages/getByChannel'](contact.feed);
      let lastInteraction = 0;
      if(msg.data.type != 'reminder') {
        lastInteraction = msg.ts;
      }
      msgs.forEach(contactMsg => {
        if(contactMsg.idWorldMessage != msg.idWorldMessage && contactMsg.data.type != 'reminder' && contactMsg.data.type != 'changeStatus' ) {
          if(contactMsg.ts > lastInteraction) {
            lastInteraction = contactMsg.ts;
          }
        }
      });
      if(lastInteraction == 0) {
        lastInteraction = '';
      }
      return lastInteraction;
    },
    removeFeed() {
      this.$http
        .post("contact/deletemessage", {
          msg: this.msg,
          contactId:this.contact.idContactsContact
        }, {
          withCredentials: true
        })
        .then(response => {
          this.$store.dispatch("messages/delete", {
            vlf: this.$vlf("messages"),
            obj: response.data.msg
          }),
          this.$store.dispatch("contacts/update", {
            vlf: this.$vlf("contacts"),
            objs: [response.data.contact]
          }),
          this.$store.dispatch("feedBoardAssocs/deleteMultiple", {
            vlf: this.$vlf("feedBoardAssocs"),
            objs: response.data.assocs
          });
        })
        .catch(error => {
          this.contact.lastFeedDate = this.getLastFeedDate(this.contact,this.msg);
          Promise.all([
            this.$store.dispatch("messages/delete", {
              vlf: this.$vlf("messages"),
              obj: this.msg
            }),
            this.$store.dispatch("contacts/update", {
              vlf: this.$vlf("contacts"),
              obj: this.contact
            }),
            this.$store.dispatch('offline/saveSyncTuple', {
              _vue: this,
              _class: "WorldMessage",
              _table: "messages",
              mode: 'delete',
              type: 'obj',
              obj: this.msg
            }),
            this.$store.dispatch('offline/saveSyncTuple', {
              _vue: this,
              _class: "ContactsContact",
              _table: "contacts",
              mode: 'edit',
              type: 'obj',
              obj: this.contact
            })
            // this.$anm22.saveSyncTuple(this, "WorldMessage", "delete", this.msg)
          ]);
        })
        .finally(() => {
          this.$anm22.eventBus.$emit("wg-modal-close");
        });
    },
    getImageByCategory(category) {
      switch (category) {
         case "meet":
          return this.$anm22.icons.getWorldIcon("googleMeet");
          break;
        case "twitter":
          return this.$anm22.icons.getWorldIcon("twitter");
          break;
        case "slack":
          return this.$anm22.icons.getWorldIcon("slack");
          break;
        case "whatsapp":
          return this.$anm22.icons.getWorldIcon("whatsapp");
          break;
        case "zoom":
          return this.$anm22.icons.getWorldIcon("zoomLogo");
          break;
        case "fb":
          return this.$anm22.icons.getWorldIcon("facebook");
          break;
        case "email":
          return this.$anm22.icons.getWorldIcon("email");
          break;
        case "ig":
          return this.$anm22.icons.getWorldIcon("instagram");
          break;
        case "hang":
          return this.$anm22.icons.getWorldIcon("hangouts");
          break;
        case "skype":
          return this.$anm22.icons.getWorldIcon("skype");
          break;
        case "linkedin":
          return this.$anm22.icons.getWorldIcon("linkedin");
          break;
        case "inbox":
          return this.$anm22.icons.getWorldIcon("inbox");
          break;
        case "messenger":
          return this.$anm22.icons.getWorldIcon("messenger");
          break;
        case "discord":
          return this.$anm22.icons.getWorldIcon("discord");
          break;
        case "teams":
          return this.$anm22.icons.getWorldIcon("microsoftTeams");
          break;
      }
    }
  },
  components: {
    FeedItemCall,
    FeedItemMsg,
    FeedItemMeeting,
    FeedItemReminder,
    FeedItemActionMsg,
    FeedItemChangeStatus,
    NewFeedDialog,
    ImportFeed
  }
};
</script>

<style lang="scss" scoped>
.msg-container {
  flex-wrap: nowrap;
  box-sizing: border-box;
  border-radius: 8px;
  background-color: #fff;
  border: 1.5px solid #dbdbdb;
  width: auto;
  width: 90%;
  max-width: 600px;
  min-width: 200px;
  padding: 5px;
  margin-top: 10px;
  &.temp {
    opacity: 0.4;
  }
  &.same-user {
    margin-top: 2px;
    & .msg-body {
      margin: 5px 0;
    }
  }
  // Messaggio inviato da me
  &.personal {
    padding: 5px;
    border: none;
    background-color: #efefef;
    margin-left: auto;
  }

  .msg-action-btn {
    padding: 1px;
    margin: 0 0 0 5px;
    width:20px;
    height: 20px;
    object-fit: contain;
    object-position: center;
    opacity: 0.7;
    cursor: pointer;
  }
}
.type-icon {
  width: 20px;
  object-fit:contain;
  height: 20px;
  margin-right: 10px;
  border-radius: 50%;
  padding: 2px;
}
</style>
